import React from "react";

const BottonAlign = ({ width = 14, height = 14, selected }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5 16.5V17.5H0.5V16.5H14.5Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.5 12.5V15.5H5.5V12.5H9.5Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.5 8.5V11.5H5.5V8.5H9.5Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.5 4.5V7.5H5.5V4.5H9.5Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.5 0.5V3.5L5.5 3.5V0.5L9.5 0.5Z"
        fill={selected ? "white" : "black"}
      />
    </svg>
  );
};

export default BottonAlign;
